import { generateUUID } from "shared/lib/generateUUID"

export function toNull<T>(value: T | null | undefined): T | null {
  return value ?? null
}

export function toNumber(value: unknown): number {
  return typeof value === "number" && !isNaN(value) ? value : 0
}

export function toDate(value: string | null | undefined): string {
  return typeof value === "string" ? value : new Date().toISOString()
}

export function toUUID(value: string | null | undefined): string {
  return value ?? generateUUID()
}
